import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getRequest } from 'services/api';
import { DISCOUNT_TYPES, RECURRING_TYPES } from 'utils/constants';
import { convertToHi } from 'utils/dateHelpers';
const InvoiceViewContext = createContext();

export const InvoiceViewProvider = ({ children }) => {
    const { invoice_number } = useParams();

    const [invoice, setInvoice] = useState({
        form: {
            invoice_number: invoice_number,
            name: "",
            footer: "",
            enable_payment_gateway: false,
            tax: 0,
            discount: null,
            discount_type: DISCOUNT_TYPES[0].value,
            due_date: "",
            items: [],
            recipients: [],
            customer: null,
        },
        loading: false,
        error: null,
    });

    const formatDataFromAPI = (data) => {
        const reValidateData = {
            invoice_number: data.invoice_number,
            name: data.name,
            footer: data.footer,
            enable_payment_gateway: data.enable_payment_gateway,
            tax: data.tax,
            discount: data.discount,
            discount_type: data.discount_type,
            due_date: data.due_date,
            customer: data.customer,
            items: data.items,
            recipients: data.recipients.map(recipient => ({ value: recipient.id, label: recipient.name, originalData: recipient })),
            balance: data.balance,
            transactions: data.transactions,
            total_paid: data.total_paid,
        };
        return reValidateData;
    };

    const fetchInvoice = useCallback(async (invoice_number) => {
        setInvoice((prev) => ({ ...prev, loading: true }));
        try {
            const response = await getRequest(`/invoice/${invoice_number}/view`);

            if (response.success) {
                console.log('response.data', response.data);
                const reValidateData = formatDataFromAPI(response.data);
                console.log('reValidateData', reValidateData);
                setInvoice((prev) => ({ ...prev, form: reValidateData }));
            }
        } catch (error) {
            setInvoice((prev) => ({ ...prev, error: 'Failed to fetch Invoice' }));
        } finally {
            setInvoice((prev) => ({ ...prev, loading: false }));
        }
    }, [invoice_number]);

    useEffect(() => {
        fetchInvoice(invoice_number);
    }, [invoice_number]);

    return (
        <InvoiceViewContext.Provider value={{ invoice }}>
            {children}
        </InvoiceViewContext.Provider>
    );
};

// Hook untuk mengakses context loading
export const useInvoiceView = () => {
    const context = useContext(InvoiceViewContext);
    if (!context) {
        throw new Error('useInvoiceView must be used within a InvoiceViewProvider');
    }
    return context;
};